import { render, staticRenderFns } from "./OrganizationInfo.vue?vue&type=template&id=9cdbbebe&scoped=true"
import script from "./OrganizationInfo.vue?vue&type=script&lang=js"
export * from "./OrganizationInfo.vue?vue&type=script&lang=js"
import style0 from "./OrganizationInfo.vue?vue&type=style&index=0&id=9cdbbebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cdbbebe",
  null
  
)

export default component.exports